import { t } from "@lingui/macro";
import { get, post } from 'bukku/shared/ApiService';
import { all, call, delay, fork, put, select, takeEvery } from 'bukku/shared/SagaService';
import { errorSagaFn, requestSagaPullingFn, requestSagaPushingFn, successSagaFn } from "../helper";
import actions from "./actions";
import listActions from "../List/actions";
import { readLists } from 'bukku/redux/Transaction/initTransaction/helper/readLists';
import { L } from "bukku/redux/List/reducer";

const useDummyCpApps = false;

const successKeys = [
    actions.CP_READ_APPS_SUCCESS,
    actions.CP_ACTIVATE_APP_SUCCESS,
];

const errorKeys = [
    actions.CP_READ_APPS_ERROR,
    actions.CP_ACTIVATE_APP_ERROR,
];

const getSuccessMsg = action => {
    const { type } = action; // { data, type }
    switch (type) {
        case actions.CP_READ_APPS_SUCCESS:
            return null;
        case actions.CP_ACTIVATE_APP_SUCCESS:
            return t`App activated.`;
        default:
            return null;
    }
};

/* PROVIDERS */
export function* readAllApps() {
    yield takeEvery(actions.CP_READ_APPS_REQUEST, function* (action, context) {
        yield requestSagaPullingFn(action,
            function* () {
                if (useDummyCpApps) {
                    yield delay(1000);
                    // OK
                    yield put({
                        type: actions.CP_READ_APPS_SUCCESS,
                        apps: [
                            {
                                title: 'Bukku Accounting',
                                isActivated: true,
                                avatarTitle: 'A',
                                avatarColor: '#1FB6C6',
                            },
                            {
                                title: 'Bukku MiniPOS',
                                isActivated: false,
                                avatarTitle: 'M',
                                avatarColor: '#faad14',
                            },
                        ],

                    });
                }
                else {
                    const response = yield call(get, '/apps', null, context);
                    const data = yield response.data;

                    // OK
                    yield put({
                        type: actions.CP_READ_APPS_SUCCESS,
                        apps: data,
                    });
                }
            });
    });
}

export function* activateApp() {
    yield takeEvery(actions.CP_ACTIVATE_APP_REQUEST, function* (action, context) {
        yield requestSagaPushingFn(action,
            function* ({ name }) {
                const response = yield call(post, `/apps/activate`, { name }, context);
                const data = yield response.data;

                // OK
                yield put({
                    type: actions.CP_ACTIVATE_APP_SUCCESS,
                    apps: data,
                });

                // after activate, read flow streams again to update sidebar
                yield readLists([L.flow_streams], {}, false, true);
                const flowStreams = yield select(state => state.List.flowStreams);
                yield put({
                    type: listActions.LIST_CHANGE_FLOW_STEAMS,
                    flowStreams,
                });
            });
    });
}

export default function* rootSaga() {
    yield all([
        fork(successSagaFn(successKeys, getSuccessMsg)),
        fork(errorSagaFn(errorKeys)),

        fork(readAllApps),
        fork(activateApp),
    ]);
}
